import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { UserAuthApiService } from '../../shared/services/auth/user-auth-api.service';
import { AuthStateService } from './auth-state.service';

export const publicOnlyGuard: CanActivateFn = (_, state) => {
    const userAuthApiService = inject(UserAuthApiService);
    const authStateService = inject(AuthStateService);

    return userAuthApiService.checkAuth().pipe(
        tap(() => {
            // Mark that we're on a public route (not protected)
            authStateService.setOnProtectedRoute(false);
        }),
        catchError(() => {
            // Mark that we're on a public route (not protected)
            authStateService.setOnProtectedRoute(false);
            return of(false);
        }),
        map((isAuthenticated) => {
            // User is not authenticated, allow access to public routes
            return !isAuthenticated;
        })
    );
};

